<template>
  <!-- Modal Error -->
  <b-modal
    :id="id"
    hide-footer
    hide-header
    no-close-on-backdrop
    :modal-class="isV2 ? 'modal-v2-wrapper' : 'success-popup success-popup_wrong'"
    no-fade
  >
    <div
      v-if="isV2"
      class="modal-v2-content"
    >
      <!-- Icon -->
      <div class="modal-v2-icon error">
        <svg
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
          />
          <line
            x1="15"
            y1="9"
            x2="9"
            y2="15"
          />
          <line
            x1="9"
            y1="9"
            x2="15"
            y2="15"
          />
        </svg>
      </div>
      <!-- Title -->
      <h2 class="modal-v2-title">
        {{ error.title }}
      </h2>
      <!-- Message -->
      <p class="modal-v2-message">
        {{ error.info }}
      </p>
    </div>
    <!-- Footer outside content to span full width -->
    <div
      v-if="isV2"
      :class="['modal-v2-footer', error.title === 'Payment Error' ? 'two-buttons' : '']"
    >
      <b-button
        class="btn btn-outline-secondary"
        @click="hideModal"
      >
        {{ $t('errorpopup.close') }}
      </b-button>
      <b-button
        v-if="error.title === 'Payment Error'"
        class="btn btn-dark"
        @click="retryPayment()"
      >
        Retry
      </b-button>
    </div>
    <div
      v-else
      class="text-center modal-complete"
    >
      <svg class="icon icon-icon-popup-wrong">
        <use xlink:href="#icon-icon-popup-wrong" />
      </svg>

      <h2 style="white-space: normal;">
        {{ error.title }}
      </h2>

      <div class="popup-meta">
        {{ error.info }}
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <b-button
          v-if="error.title === 'Payment Error'"
          variant="outline-primary"
          class="w-100 m-3"
          @click="retryPayment()"
        >
          <!-- TODO: need to add translation -->
          Retry
        </b-button>
        <b-button
          :class="`w-100 ${error.title === 'Payment Error' ? 'm-3' : ''}`"
          variant="outline-warning"
          @click="hideModal"
        >
          {{ $t('errorpopup.close') }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
  export default {
    name: 'ModalError',
    props: {
      id: {
        default: 'modal-error',
        type: String
      },
      error: {
        type: Object,
        required: true
      },
      cancelCallback: {
        type: Function,
        required: false,
        default: () => {}
      },
      v2: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isV2() {
        // Auto-detect if in Kiosk V2 or use v2 prop
        return this.v2 || this.$route?.name?.includes('V2') || false;
      }
    },
    data () {
      return {}
    },
    methods: {
      // todo rewrite this method to a general one (name)
      retryPayment() {
        return this.$emit('retry-payment');
      },
      hideModal() {
        this.cancelCallback();
        this.$emit('hide-modal')
        this.$bvModal.hide(this.id);
      }
    }
  }
</script>
